import React from "react";

var ToggleButton = React.createClass({
  toggle: function(id){
    var status = !this.props.status;

    this.props.status = status;
    this.props.onToggle(id, status);
  },

  render: function(){
    var status = this.props.status;

    return (
      <div className={ 'c_toggle-button ' + (status ? "active" : "") } onClick={ this.toggle.bind(this, this.props.id) }>
        <a href='javascript:void(0)' className="toggle-label">{ this.props.label }</a>
      </div>
    )
  }
})

module.exports = ToggleButton;


// WEBPACK FOOTER //
// ./components/ui-components/toggle-button.js